export default __webpack_public_path__ + "static/media/instantCash.be4fe5e1.gif";